import classNames from 'classnames';

import { Game } from '~/types/game';
import { PositionLabel } from '~/components/highscores/label';
import { useHighscores } from '~/services/db/highscores';

import styles from './Ranking.module.css';

export type RankingProps = {
    className?: string;
    clientID: string;
    game: Game;
};

export function Ranking({ className, game, clientID }: RankingProps) {
    const highscores = useHighscores(clientID, game.id, 15);

    return (
        <div className={classNames(styles.container, className)}>
            <b>{game.name} Rank</b>
            <div className={styles.podium}>
                <div className={styles.flexLabel}>
                    {highscores.length > 0 && (
                        <PositionLabel
                            position={1}
                            className={styles.firstPosition}
                            player={highscores[0]}
                            score={highscores[0].score}
                        />
                    )}
                </div>
                <div className={styles.flexLabel}>
                    {highscores.length > 1 && (
                        <PositionLabel
                            position={2}
                            className={styles.secondPosition}
                            player={highscores[1]}
                            score={highscores[1].score}
                        />
                    )}
                </div>
                <div className={styles.flexLabel}>
                    {highscores.length > 2 && (
                        <PositionLabel
                            position={3}
                            className={styles.thirdPosition}
                            player={highscores[2]}
                            score={highscores[2].score}
                        />
                    )}
                </div>
            </div>
            <div className={styles.rankingContainer}>
                {highscores.slice(3, highscores.length).map((score, index) => (
                    <p key={index} className="ub-mask">{`#${index + 4} - ${score.username} ${score.score}`}</p>
                ))}
            </div>
        </div>
    );
}
